import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import PricingPage from './PricingPage.vue';
import InvoiceHistory from './InvoiceHistory.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'pricing',
          name: 'billing_pricing',
          component: PricingPage,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'invoices',
          name: 'billing_invoice_history',
          component: InvoiceHistory,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
